//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Feature from '~/components/feature';
export default {
  components: {
    Feature,
  },
  async asyncData({ $content }) {
    const data = await $content('team').fetch();
    const items = data.map((item) => {
      const firstname = item.basics.firstname;
      const lastname = item.basics.lastname;

      const name = `${firstname} ${lastname}`;
      const description = item.basics.summary;
      const image = `/img/team/${item.slug}.png`;
      const url = `/people/${item.slug}`;
      const subheading = item.basics.label;
      return { name, description, image, url, subheading, imageWidth: 360 };
    });
    return { items };
  },
  data() {
    return {
      heading: 'Team',
      description:
        'Meet the awesome team working building better software for the world.',
      items: [],
    };
  },
  head() {
    return {
      title: this.heading,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
    };
  },
};
